import React from 'react';
import ReactDOM from 'react-dom';
import Footer from './Components/Footer/Footer';
import './translations/resources'
import './index.css';
import { HashRouter as Router, Route, Switch } from "react-router-dom";
import Home from './Pages/Home'
import Post from './Pages/Post/Post'
import './normalize.css'

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <Switch>
          <Route path="/" exact component={ Home } />
          <Route path="/post/:_id"  component={ Post } />
       </Switch>
       <Footer />
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);
